import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createTemplatesNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'chart',
  text: translateFn('mnu_tempaltes_add'),
  identity: '/secure/account/templates',
}))

export default Loadable(() => import('./TemplatesForm'))
